import { Link } from "react-router-dom";
import { Heart, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grid min-h-screen place-items-center bg-parchment px-6">
      <div className="max-w-md text-center" data-testid="payment-cancel">
        <h1 className="font-display text-3xl font-black text-[#1A0F1C]">No worries — nothing was charged</h1>
        <p className="mt-3 flex items-center justify-center gap-2 text-base font-semibold text-[#5C4A61]">
          <Heart size={18} className="text-[#9B5DE5]" /> Your previews are still saved. Come back whenever you're ready.
        </p>
        <Link
          to="/create"
          className="mt-8 inline-flex min-h-[56px] items-center gap-2 rounded-full bg-[#4A235A] px-8 font-extrabold text-white transition-transform hover:-translate-y-1"
        >
          <ArrowLeft size={18} /> Back to my character
        </Link>
      </div>
    </div>
  );
}
